// export const SERVER_URL = "http://localhost:5000"
// export const SERVER_URL = "http://92.28.187.146:5000"
// export const SERVER_URL = "https://fast-bayou-03205.herokuapp.com"
export const SERVER_URL = "https://notes-server-joe4.onrender.com"
export const ALERT_TYPES = {
    ERROR: "error",
    SUCCESS: "success",
}
